import type { MediaAsset } from '@/lib/blob-service';

export interface Voice {
  id: string;
  tool: string;
  name: string;
  description: string;
  preview: MediaAsset;
  avatarUrl?: string;
  recommended?: boolean;
}

const preview = (id: string): MediaAsset => ({
  id,
  type: 'audio',
  blobUrl: `/voices/${id}.mp3`,
  fallbackUrl: `/voices/${id}.mp3`,
});

export const voices: Voice[] = [
  {
    id: 'marin',
    tool: 'openai',
    name: 'Marin',
    description: 'Premium natural delivery with clear, expressive narration',
    preview: preview('marin'),
    recommended: true,
  },
  {
    id: 'cedar',
    tool: 'openai',
    name: 'Cedar',
    description: 'Premium grounded delivery with confident clarity',
    preview: preview('cedar'),
    recommended: true,
  },
  {
    id: 'alloy',
    tool: 'openai',
    name: 'Meridian',
    description: 'Versatile, balanced narration with a natural tone',
    preview: preview('alloy'),
    avatarUrl: 'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/images/meridian.png',
  },
  {
    id: 'ash',
    tool: 'openai',
    name: 'Ember',
    description: 'Direct, composed delivery for confident storytelling',
    preview: preview('ash'),
  },
  {
    id: 'ballad',
    tool: 'openai',
    name: 'Sonnet',
    description: 'Expressive delivery for reflective and emotional stories',
    preview: preview('ballad'),
  },
  {
    id: 'coral',
    tool: 'openai',
    name: 'Coral',
    description: 'Warm, lively delivery for upbeat and conversational videos',
    preview: preview('coral'),
  },
  {
    id: 'echo',
    tool: 'openai',
    name: 'Resonance',
    description: 'Measured, resonant delivery for deliberate narration',
    preview: preview('echo'),
    avatarUrl: 'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/images/resonance.png',
  },
  {
    id: 'fable',
    tool: 'openai',
    name: 'Aurora',
    description: 'Expressive, animated delivery for characterful stories',
    preview: preview('fable'),
    avatarUrl: 'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/images/aurora.png',
  },
  {
    id: 'nova',
    tool: 'openai',
    name: 'Celesta',
    description: 'Warm, polished delivery with clear articulation',
    preview: preview('nova'),
    avatarUrl: 'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/images/celesta.png',
  },
  {
    id: 'onyx',
    tool: 'openai',
    name: 'Obsidian',
    description: 'Deep, authoritative delivery with controlled emphasis',
    preview: preview('onyx'),
    avatarUrl: 'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/images/obsidian.png',
  },
  {
    id: 'sage',
    tool: 'openai',
    name: 'Sage',
    description: 'Calm, thoughtful delivery for clear explanations',
    preview: preview('sage'),
  },
  {
    id: 'shimmer',
    tool: 'openai',
    name: 'Raylee',
    description: 'Bright, energetic delivery with natural enthusiasm',
    preview: preview('shimmer'),
    avatarUrl: 'https://bkmjmkkjkywolycz.public.blob.vercel-storage.com/images/raylee.png',
  },
  {
    id: 'verse',
    tool: 'openai',
    name: 'Cadence',
    description: 'Rhythmic, expressive delivery for punchy narration',
    preview: preview('verse'),
  },
];
